var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pdmAttributes && _vm.pdmAttributes.length)?_c('ProductPdmTable',{attrs:{"pdms":_vm.pdmAttributes,"tableClass":"table-mobile"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }